function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import { makePropType } from '../utils/propTypes';
import { SIZES as BUTTON_SIZES } from '../button/constants';
import { ICON_PROP_TYPE } from '../iconButton/constants';
import { NOTIFICATION_OPTIONS_PROP_TYPES } from '../notification/constants'; // modal types

export var TYPE_SIMPLE = 'simple';
export var TYPE_APERTURE = 'aperture';
export var TYPE_COMPLEX = 'complex';
export var MODAL_TITLE_ID = 'eds-modal-title';
export var TYPES = [TYPE_SIMPLE, TYPE_APERTURE, TYPE_COMPLEX]; // Checks that the prop has the correct length

var propLengthCheck = function propLengthCheck(props, propName, componentName) {
  var length = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 140;

  if (props[propName] > length) {
    return new Error("Invalid prop ".concat(propName, " suppied to ").concat(componentName, ". content must be ").concat(length, " characters or less."));
  }

  return null;
};

var MODAL_MESSAGE_TYPE = function MODAL_MESSAGE_TYPE(props, propName, componentName) {
  return propLengthCheck(props, propName, componentName, 32);
};

var MODAL_TITLE_TYPE = function MODAL_TITLE_TYPE(props, propName, componentName) {
  return propLengthCheck(props, propName, componentName, 180);
};

export var MODAL_MESSAGE_PROPTYPE = makePropType(MODAL_MESSAGE_TYPE);
export var MODAL_TITLE_PROPTYPE = makePropType(MODAL_TITLE_TYPE);
export var MODAL_CHILDREN_PROPTYPE = PropTypes.node;
export var MODAL_PROP_TYPES = {
  children: MODAL_CHILDREN_PROPTYPE.isRequired,

  /**
   * The type of modal that should be shown
  */
  type: PropTypes.oneOf(TYPES),

  /**
  * A function with the desired behavior on mount (componentDidMount)
  */
  onMount: PropTypes.func,

  /**
   * Is the dialog currently shown?
  */
  isShown: PropTypes.bool,

  /**
   * Removes min height for simple Modals
  */
  noMinHeight: PropTypes.bool,

  /**
   * Is the dialog closable?
  */
  isClosable: PropTypes.bool,

  /**
   * Removes padding on the modal container
  */
  noPadding: PropTypes.bool,

  /**
   * Add a class to the modals wrapper <dialog>
  */
  dangerouslySetContainerClassName: PropTypes.shape({
    __className: PropTypes.string
  })
};
export var MODAL_BODY_PROP_TYPES = {
  children: MODAL_CHILDREN_PROPTYPE.isRequired,

  /**
  * A function with the desired behavior on close
  */
  onClose: PropTypes.func,

  /**
   * The icon to use for the secondary header action
   */
  headerActionIconType: ICON_PROP_TYPE,

  /**
   * The title for the secondary header action icon
  */
  headerActionTitle: EBPropTypes.translation,

  /**
  * A function with the desired behavior on clicking the secondary header action icon
  */
  onHeaderAction: PropTypes.func,

  /**
   * The title displayed above the content
  */
  title: MODAL_TITLE_PROPTYPE,

  /**
   * The title displayed above the content
  */
  secondaryTitle: PropTypes.node,

  /**
   * The illustration displayed inside the modal
  */
  illustration: PropTypes.node,

  /**
   * The type of button that should be shown for primary button
  */
  primaryType: PropTypes.string,

  /**
   * The text that should be shown across the primary button
  */
  primaryText: PropTypes.node,

  /**
   * The size of the primary button
  */
  primarySize: PropTypes.oneOf(_toConsumableArray(BUTTON_SIZES)),

  /**
   * Whether the primary button should be disabled
  */
  primaryIsDisabled: PropTypes.bool,

  /**
   * The function that should be triggered on primary button click
  */
  onPrimaryAction: PropTypes.func,

  /**
   * The type of button that should be shown for secondary button
  */
  secondaryType: PropTypes.string,

  /**
   * The text that should be shown across the secondary button
  */
  secondaryText: PropTypes.node,

  /**
   * Whether the secondary button should be disabled
  */
  secondaryIsDisabled: PropTypes.bool,

  /**
   * The function that should be triggered on secondary button click
  */
  onSecondaryAction: PropTypes.func,

  /**
   * The node that will act as a tertiary action
  */
  tertiaryNode: PropTypes.node,

  /**
   * The function that should be triggered on tertiary node click
  */
  onTertiaryAction: PropTypes.func,

  /**
   * A message to show above the button bar
  */
  buttonBarMessage: EBPropTypes.translation,

  /**
   * True if the modal body should be empty, i.e. not include the header, footer, or body containers
   */
  modalBodyIsEmpty: PropTypes.bool,

  /**
   * Disables the ability to close the modal by clicking the outside overlay
   */
  disableCloseOnClickOutside: PropTypes.bool,

  /**
   * Used to render notifications inside the modal header.
   */
  notificationOptions: PropTypes.oneOfType([NOTIFICATION_OPTIONS_PROP_TYPES, PropTypes.arrayOf(NOTIFICATION_OPTIONS_PROP_TYPES)]),

  /**
   * Changes the role attribute to dialog
   */
  roleIsDialog: PropTypes.bool
};
export var COLLAPSIBLE_PANE_LAYOUT_PROP_TYPES = {
  /**
   * The content to display next to the pane
  */
  content: PropTypes.node,

  /**
   * The content to display inside the pane, if any
  */
  pane: PropTypes.node,

  /**
   * Whether pane is open or closed
  */
  isPaneOpen: PropTypes.bool
};